import LogoUrl from "../../../../../logo.png";
import * as React from 'react';
export default {
  LogoUrl,
  React
};